export * from './table-config.interface';
export * from './form-fields.interface';